import './index.css';
import { getNotNullish } from '@hg-akademie-ban/vamos-viva-type-utils';
import { setDefaultOptions } from 'date-fns';
import { de } from 'date-fns/locale';
import * as React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AzureApplication, getBackendConfig } from './main.utils';
import { BackendConfigContext } from './utils/BackendInfrastructure/BackendConfigContext';

try {
  const backendConfig = await getBackendConfig();
  const msalInstance = await AzureApplication.createFromBackendConfig(backendConfig);

  setDefaultOptions({ locale: de });

  createRoot(getNotNullish(document.querySelector('#root'))).render(
    <React.StrictMode>
      <BackendConfigContext value={backendConfig}>
        <App msalInstance={msalInstance} />
      </BackendConfigContext>
    </React.StrictMode>,
  );
} catch (error: unknown) {
  createRoot(getNotNullish(document.querySelector('#root'))).render(
    <React.StrictMode>
      <ErrorBoundary error={error} />
    </React.StrictMode>,
  );
}
